import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskChannelsPortalRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-channels-portal',
	path: '/jira/servicedesk/projects/:projectKey/settings/channels/portal-settings',
	exact: true,
};
